module.exports = __webpack_public_path__ + "static/labs-img-3f95fed29c1fb03dc8affc2509b2e29c.png";